import React, { useEffect } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../App.css";
import { Link } from "react-router-dom";
import NewsletterSection from "./NewsLetter";
import newsletter_1 from "../assests/Newsletter1.png"
import newsletter_2 from "../assests/Newsletter2.png"
import newsletter_3 from "../assests/Newsletter3.png"
import newsletter_4 from "../assests/Newsletter4.png"
import newsletter_5 from "../assests/Newsletter5.png"
import newsletter_6 from "../assests/Newsletter6.png"
import Aos from "aos";
import HeroSection from "./HeroSection";


function NewsLetterList() {
    const cards = [
        {
          image: newsletter_1,
          title: "Phishing attacks IOS and Android to steal banking information",
          date: "23 Aug 2024",
          description: "Revolutionizing education with innovation and technology to empower modern learners.",
          // path: "/trying",
          pdfUrl: "https://kristellaraerospacepvtltd-my.sharepoint.com/:b:/g/personal/manisha_kristellar_com/EQNhzGnbRNVHk3Ba6BI5oMoBvbYAPwb-EDE0DvArYblg5w?e=hDuiFz",
          desc1: "Discover how emerging phishing tactics are redefining mobile threats and increasing risks for digital users. Cybercriminals are employing advanced techniques, such as Progressive Web Applications (PWAs), to compromise security and access sensitive banking data.",
          desc2: "Are you prepared to face the evolving challenges in mobile security?",
          desc3: "From fake banking apps disguised as legitimate platforms to deepfake-driven identity fraud, we explore the tools and methods being used to exploit unsuspecting users. Attackers rely on deceptive links, fake app store pages, and social engineering techniques to infiltrate devices and extract personal information.",
          desc4: "Stay informed and secure as we navigate the cutting edge of cybersecurity innovation. Let’s work together to build a safer digital future. Read, learn, and take steps to protect yourself today!",
          flipbook: "https://online.fliphtml5.com/rsgxj/wcaj/",
          
        },
        {
          image: newsletter_2,
          title: "Stealthy cyberespionage campaign remained undiscovered for months",
          date: "23 Aug 2024",
          description: "Digital identity streamlines authentication, enabling secure service access with minimal friction.",
          // path: "/trying1",
          pdfUrl: "https://kristellaraerospacepvtltd-my.sharepoint.com/:b:/g/personal/manisha_kristellar_com/Eb49J1sTGH9HtiIOFauceu8BRwlX5NxbaQTkhkTN2jFxhQ?e=QSfMLM",
          desc1: "A covert cyberespionage campaign targeting an Indian defense product manufacturer remained undetected for months, exposing significant vulnerabilities. With custom malware and sophisticated techniques, the attackers demonstrated a high level of expertise in evading detection and extracting sensitive data.",
          desc2: "Are you ready to explore the tactics of a highly skilled adversary?",
          desc3: "From the deployment of the EREBUS custom backdoor to the use of modified reverse proxies and legitimate tools like PowerShell scripts and remote access software, this campaign represents a new level of cyber threat. Attackers exfiltrated data, performed reconnaissance, and maintained persistent access using advanced methods like WMI abuse, tunneling tools, and remote scheduled tasks.",
          desc4: "Get ready to delve into the details of this stealthy operation and learn about the evolving challenges in cybersecurity. Together, let’s uncover the threats and innovate for a safer tomorrow. Read, explore, and imagine a future where such threats are swiftly detected and neutralized!",
          flipbook: "https://online.fliphtml5.com/rsgxj/kyya/",
        },
        {
          image: newsletter_3, 
          title: "DNS Tunneling payload: Next-Gen malware delivery",
          date: "31 Aug 2024",
          description: "Embrace the Future with Green Coding",
          // path: "/trying2",
          pdfUrl: "https://kristellaraerospacepvtltd-my.sharepoint.com/:b:/g/personal/manisha_kristellar_com/ETIn8NqL6GhPjALp45nLeqgBgD10CI0FDJz9WaIVrN43Rw?e=C4NLgP",
          desc1: "In our increasingly connected world, digital identities have become essential for both personal and professional engagements. Whether it’s accessing financial services, communicating online, or verifying credentials, digital identities simplify interactions and improve user experiences.",
          desc2: "Are you prepared to navigate the future of digital identity?",
          desc3: "This edition of The Digital Identity takes you into the evolving landscape of identity systems. Explore groundbreaking advancements like biometric authentication, decentralized identity models, and next-generation security measures. Stay informed with insights on industry trends, regulatory updates, and practical examples of how robust digital identities empower individuals and businesses alike.",
          desc4: "Gain expert perspectives on safeguarding privacy, maintaining compliance, and building resilient digital strategies. Subscribe now to stay updated on the future of digital identity and secure your role in the digital era.",
          flipbook: "https://online.fliphtml5.com/rsgxj/oawk/",
        },
        {
          image: newsletter_4, 
          title: "Converged digital infrastructure :The foundation of tomorrows cyber resilient world",
          date: "06-09-2024",
          description: "Embrace the Future with Green Coding",
          // path: "/trying3",
          pdfUrl: "https://kristellaraerospacepvtltd-my.sharepoint.com/:b:/g/personal/manisha_kristellar_com/ESVMtbnRQblMtF_yzn7yL4IBCGFE4ByMolZ7LvBrE--Urw?e=05ukHq",
          desc1: "As the demand for cloud computing, IoT, and AI grows, traditional infrastructures struggle to keep pace. Converged Digital Infrastructure (CDI) revolutionizes this by merging computing, storage, networking, and virtualization into one unified, fast, and secure platform, enabling businesses to innovate and scale efficiently.",
          desc2: " However, CDI’s interconnected nature also opens the door to sophisticated cyber threats. With ransomware, data breaches, and denial-of-service attacks on the rise, strong cybersecurity is crucial.",
          desc3: "Kristellar Cyberspace leads the way in securing CDI through advanced solutions like zero-trust architectures, AI-driven threat detection, end-to-end encryption, and continuous monitoring. Our multi-layered approach ensures protection at every point of entry, safeguarding your infrastructure from evolving threats.As the digital world connects more, Kristellar Cyberspace ensures your CDI remains secure, resilient, and future-proofed.",
          desc4: "Stay Secure, Innovate with Confidence!",
          flipbook: "https://online.fliphtml5.com/rsgxj/iyvt/" ,
        },
        {
          image: newsletter_5,
          title: "The future of mobility: Why software defined vehicles are revolutionizing the auto industry",
          date: "13-09-2024",
          description: "Embrace the Future with Green Coding",
          // path: "/trying3",
          pdfUrl: "https://kristellaraerospacepvtltd-my.sharepoint.com/:b:/g/personal/manisha_kristellar_com/EQRDkKfWh-JFpXxXo3x56XEBxyOBekbuqVyMFCsfMlr7Gg?e=mK9uhR",
          desc1: "Software-Defined Vehicles (SDVs) are revolutionizing the automotive industry by shifting control from hardware to software, enabling continuous upgrades and real-time decision-making. Powered by AI, cloud computing, and real-time data analytics, SDVs offer autonomous driving, seamless over-the-air updates, and deep integration with smart cities and IoT networks. These intelligent, adaptable vehicles are reshaping the future of mobility.",
          desc2: "However, with this transformation comes new cybersecurity challenges. SDVs are vulnerable to threats such as unauthorized software updates, data manipulation through Vehicle-to-Everything (V2X) communication, and remote control vulnerabilities, making robust cybersecurity essential to safeguard these interconnected systems.",
          desc3: "Kristellar Cyberspace provides cutting-edge security solutions for SDVs, including AES-256 encryption, AI-driven threat detection, secure V2X communication, and continuous patch management. These strategies ensure that SDVs are protected from emerging cyber threats and remain secure as they evolve.As SDVs continue to define the future of automotive technology, ensuring cybersecurity remains a top priority for successful deployment and integration.",
          desc4: "Drive Securely, Innovate with Confidence!",
          flipbook: "https://online.fliphtml5.com/rsgxj/ihzl/" ,
        },
        {
          image: newsletter_6,
          title: "System-on-Chip (SoC) Security: Safeguarding the Engines of Modern Technology",
          date: "20-09-2024",
          description: "Embrace the Future with Green Coding",
          // path: "/trying3",
          pdfUrl: "https://kristellaraerospacepvtltd-my.sharepoint.com/:b:/g/personal/manisha_kristellar_com/EZ_BgQgtuGNJg712Gy8_kWUB35gD4lcKUIOfkPrjogH00Q?e=4yMU3a",
          desc1: "System-on-Chip (SoC) technology is integral to devices like smartphones, medical systems, and IoT, but its increasing role in critical infrastructure exposes it to growing security risks. Vulnerabilities such as hardware trojans, firmware exploits, and side-channel attacks can have catastrophic effects on industries like healthcare and automotive.",
          desc2: "Kristellar Cyberspace offers advanced solutions to safeguard SoCs. Our AI-driven threat detection monitors real-time behavior, while end-to-end encryption protects sensitive data. We also implement firmware integrity checks to ensure only trusted updates are applied, preventing malicious attacks.",
          desc3: "As SoCs power everything from consumer devices to critical systems, robust security is vital. Kristellar Cyberspace’s tailored defense solutions ensure your SoC-driven devices remain secure against emerging threats.",
          desc4: "Secure your future with Kristellar Cyberspace.",
          flipbook: "https://online.fliphtml5.com/rsgxj/kypw/",
        },
      ];

      useEffect(() => {
          Aos.init({
            duration: 1000,
            once: true,
            easing: 'ease-out'
          });
          window.scrollTo(0, 0);
        }, []);

        const handleReadMore = (card) => {
          sessionStorage.setItem('newsletterData', JSON.stringify(card));
      };


  return (
    <div className="app">
      <Header />
      <Navbar />

      <HeroSection 
        title="Newsletter" 
        breadcrumb={
          <>
            <Link to={"/publication"}>NewsLetter</Link> 
          </>
        } 
      />

      <div className="container mx-auto px-12 sm:px-6 lg:px-20 2xl:px-52 py-6 lg:py-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            data-aos="fade-up"
                            className="bg-white shadow-md rounded-md overflow-hidden transition-transform transform hover:scale-105"
                        >
                            <img
                                src={card.image}
                                alt={card.title}
                                className="w-full h-48 sm:h-52 lg:h-60 object-cover"
                            />
                            <div className="p-4">
                                <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2 line-clamp-2">
                                    {card.title}
                                </h2>
                                <p className="text-base sm:text-lg text-gray-500 mb-2">{card.date}</p>
                                <p className="text-gray-600 text-sm sm:text-md mb-4 line-clamp-2">{card.desc1}</p>
                                <div className="flex justify-between items-center">
                                    <Link 
                                        to={"/weeklynewsletter"}
                                        onClick={() => handleReadMore(card)}
                                        className="text-blue-500 font-bold hover:underline text-base sm:text-lg"
                                    >
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

      <NewsletterSection />

      <Footer />
    </div>
  );
}

export default NewsLetterList;